/**
 * Shared MUI `sx` objects for the workflow / batch filter bar (Autocomplete + Paper).
 * Extracted so the presentational component stays small and styles are reusable.
 */

/**
 * Outlined Autocomplete / TextField chrome for QC task dropdowns.
 * Mobile: compact height + smaller type; `md+`: standard density.
 */
export const qcTaskDropdownSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: { xs: 1, sm: 1.25, md: 1.5 },
    backgroundColor: 'background.paper',
    fontWeight: 500,
    minHeight: { xs: 36, sm: 38, md: 40 },
    alignItems: 'center',
    fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'primary.main',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: { xs: 1, sm: 2 },
    },
  },
  '& .MuiInputLabel-outlined': {
    fontWeight: 500,
    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': { fontWeight: 600 },
  '& .MuiAutocomplete-input': {
    fontWeight: 500,
    py: { xs: 0.35, sm: 0.45, md: 0.5 },
    fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
  },
};

/** Card-style container for the two Autocompletes (responsive padding). */
export const qcTaskFilterBarPaperSx = {
  p: { xs: 0.75, sm: 1.25, md: 2 },
  borderRadius: { xs: 0.75, sm: 1, md: 1.25 },
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
};

/** Autocomplete list: compact rows on mobile, comfortable from tablet up. */
export const qcTaskAutocompleteListboxSlotProps = {
  sx: {
    maxHeight: { xs: 'min(42dvh, 260px)', sm: 260, md: 320 },
    py: { xs: 0.25, sm: 0.5 },
    fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
    '& .MuiAutocomplete-option': {
      minHeight: { xs: 36, sm: 40, md: 40 },
      py: { xs: 0.35, sm: 0.5, md: 0.5 },
      px: { xs: 1, sm: 1.25 },
      alignItems: 'center',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
};
